
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Vaga } from "app/pages/full-pages/vaga/vaga.model";
import { Observable } from "rxjs";

export abstract class AbTipoVaga extends AppService {

  abstract getVagas();
  abstract getAllTipoDeVagas(filter: AppFilter): Observable<any>;
  abstract saveTipoVaga(vaga: Vaga): Observable<any>;
  abstract desativar(id: number);

}